import { createSelector } from 'reselect';
import { getProfileOptions } from './EntitySelector';
import { getCurrentUserLocale } from './AttributesSelector';
export const getLanguagesToDefaultLocales = createSelector([getProfileOptions], profileOptions => profileOptions.get('languageOptions').reduce((acc, option) => {
  acc[option.get('language')] = option.get('defaultLocale');
  return acc;
}, {}));

// Returns either the default locale for a language
// or if the exising locale is valid for the new language
// return that.
export const getSelectedLocaleFromNewLanguage = language => createSelector([getProfileOptions, getCurrentUserLocale, getLanguagesToDefaultLocales], (profileOptions, currentLocale, languagesToDefaultLocales) => {
  const defaultNewLocale = languagesToDefaultLocales[language];
  const availableLocaleForNewLanguage = profileOptions.get('languageOptions').find(languageOption => languageOption.get('language') === language).get('availableLocale');

  // If the new language supports the existing locale selection, return it.
  if (availableLocaleForNewLanguage.includes(currentLocale)) {
    return currentLocale;
  }
  return defaultNewLocale;
});
export const getSupportsSignature = createSelector([getProfileOptions], profileOptions => profileOptions.get('supportsSignature'));
export const getSupportsConnectedEmailAddresses = createSelector([getProfileOptions], profileOptions => profileOptions.get('supportsConnectedEmailAddresses'));